import {
  AUTH_SET_ACCESS_SESSION,
  AUTH_SET_ACCESS_TOKEN,
  AUTH_SET_CUSTOMER_CONTACT_ID,
  AUTH_SET_CUSTOMER_CONTACT_NAME,
  AUTH_SET_CUSTOMER_ID,
  AUTH_SET_CUSTOMER_NAME,
  AUTH_SET_EMAIL,
  AUTH_SET_ERROR,
  AUTH_SET_EXPIRY,
  AUTH_SET_REFRESH_TOKEN,
  AUTH_SET_ROLE,
  AUTH_SET_STATUS,
  AUTH_SET_USER_ID,
  AUTH_SET_USER_LAST_UPDATE,
  AUTH_SET_CUSTOMER_LAST_UPDATE,
  AUTH_SET_WELCOME_WATCHED,
  AUTH_AUTO_REFRESH,
  AUTH_CLEAR_AUTO_REFRESH
} from '@/store/mutation-types';
import {
  AUTH_CHECK_LOGIN,
  AUTH_CUSTOMER_CONTACT,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_RESET_PASSWORD,
  CLEAR_AUTH,
  AUTH_REQUEST_RESET,
  AUTH_CONFIRM_RESET,
  CLEAR_FETCH_CACHE,
  AUTH_WELCOME_WATCHED,
} from '@/store/action-types';
import AuthRepository from "@/auth/AuthRepository";
import moment from "moment";
import Customer from '../../models/Customer';
import Contact from '../../models/Contact';
import Location from '../../models/Location';
import User from '../../models/User';
import CustomerContact from '../../models/CustomerContact';

let mutation_types = {
  AUTH_SET_USER_ID,
  AUTH_SET_EMAIL,
  AUTH_SET_ACCESS_TOKEN,
  AUTH_SET_ACCESS_SESSION,
  AUTH_SET_EXPIRY,
  AUTH_SET_REFRESH_TOKEN,
  AUTH_SET_CUSTOMER_ID,
  AUTH_SET_CUSTOMER_NAME,
  AUTH_SET_CUSTOMER_CONTACT_ID,
  AUTH_SET_CUSTOMER_CONTACT_NAME,
  AUTH_SET_STATUS,
  AUTH_SET_ERROR,
  AUTH_SET_ROLE,
  AUTH_SET_USER_LAST_UPDATE,
  AUTH_SET_CUSTOMER_LAST_UPDATE,
  AUTH_SET_WELCOME_WATCHED,
  AUTH_AUTO_REFRESH,
  AUTH_CLEAR_AUTO_REFRESH
};

let action_types = {
  CLEAR_AUTH,
  AUTH_LOGOUT,
  AUTH_CHECK_LOGIN,
  AUTH_LOGIN,
  AUTH_RESET_PASSWORD,
  AUTH_CUSTOMER_CONTACT,
  AUTH_REQUEST_RESET,
  AUTH_CONFIRM_RESET,
  AUTH_WELCOME_WATCHED,
};

const state = {
  user_id: getLocalStorage('auth__user_id'),
  user_email: getLocalStorage('auth__user_email'),
  access_token: getLocalStorage('auth__access_token'),
  access_session: getLocalStorage('auth__access_session'),
  expiry: getLocalStorage('auth__expiry'),
  refresh_token: getLocalStorage('auth__refresh_token'),
  role: getLocalStorage('auth__role'),
  customer_id: getLocalStorage('auth__customer_id'),
  customer_name: getLocalStorage('auth__customer_name'),
  customer_contact_id: getLocalStorage('auth__customer_contact_id'),
  customer_contact_name: getLocalStorage('auth__customer_contact_name'),
  user_last_update: getLocalStorage('auth__user_last_update'),
  customer_last_update: getLocalStorage('auth__customer_last_update'),
  welcome_watched: getLocalStorage('auth__welcome_watched'),
  validation: null,
  auto_refresh: null,
  status: null,
  error: null,
}

function getLocalStorage(key) {
  let val = localStorage.getItem(key);
  if(val && val !== '') {
    return val;
  }
  return null;
}

const getters = {
  getAuthUserID: state => state.user_id,
  getAuthEmail: state => state.user_email,
  getAuthAccessToken: state => state.access_token,
  getAuthSession: state => state.access_session,
  getAuthExpiry: state => state.expiry,
  getAuthRefreshToken: state => state.refresh_token,
  getAuthRole: state => state.role,
  getAuthCustomerID: state => state.customer_id,
  getAuthCustomerName: state => state.customer_name,
  getAuthCustomerContactID: state => state.customer_contact_id,
  getAuthCustomerContactName: state => state.customer_contact_name,
  getAuthenticationStatus: state => state.status,
  getAuthenticationError: state => state.error,
  isAuthenticated: state => !!state.access_token,
  hasError: state => !!state.error,
  isAdmin: state => state.role !== 'CustomerContact',
  isUserNew: state => !!state.access_token && state.role === 'CustomerContact' && !state.user_last_update,
  isUserOutdated: state => !!state.access_token && state.role === 'CustomerContact' && (!state.user_last_update || moment().diff(moment(state.user_last_update), 'months') >= 6),
  isCustomerOutdated: state => !!state.access_token && state.role === 'CustomerContact' && (!state.customer_last_update || moment().diff(moment(state.customer_last_update), 'months') >= 6),
  hasWatchedWelcomeVideo: state => !!state.welcome_watched,
  getAuthState: state => state,
};

function cleanMutationValue(val) {
  if(val && val !== '') {
    return val;
  }
  return null;
}

function setLocalStorageItem(state, key) {
  if(!state || !key) {
    return false;
  }
  let val = state[key];
  if(val) {
    return localStorage.setItem('auth__'+key, val);
  } else {
    return localStorage.removeItem('auth__'+key);
  }
}

const mutations = {
  AUTH_SET_USER_ID: function(state, user_id){
    state.user_id = cleanMutationValue(user_id);
    setLocalStorageItem(state, 'user_id');
    //localStorage.setItem('auth__user_id', state.user_id);
  },
  AUTH_SET_EMAIL: function(state, email){
    state.email = cleanMutationValue(email);
    setLocalStorageItem(state, 'email');
    //localStorage.setItem('auth__email', state.email);
  },
  AUTH_SET_ACCESS_TOKEN: function(state, access_token){
    state.access_token = cleanMutationValue(access_token);
    setLocalStorageItem(state, 'access_token');
    //localStorage.setItem('auth__access_token', state.access_token);
  },
  AUTH_SET_EXPIRY: function(state, expiry){
    state.expiry = cleanMutationValue(expiry);
    setLocalStorageItem(state, 'expiry');
    //localStorage.setItem('auth__expiry', state.expiry);
  },
  AUTH_SET_ACCESS_SESSION: function(state, access_session){
    state.access_session = cleanMutationValue(access_session);
    setLocalStorageItem(state, 'access_session');
    //localStorage.setItem('auth__access_session', state.access_session);
  },
  AUTH_SET_REFRESH_TOKEN: function(state, refresh_token){
    state.refresh_token = cleanMutationValue(refresh_token);
    setLocalStorageItem(state, 'refresh_token');
    //localStorage.setItem('auth__refresh_token', state.refresh_token);
  },
  AUTH_SET_ROLE: function(state, role){
    state.role = cleanMutationValue(role);
    setLocalStorageItem(state, 'role');
  },
  AUTH_SET_CUSTOMER_ID: function(state, customer_id){
    state.customer_id = cleanMutationValue(customer_id);
    setLocalStorageItem(state, 'customer_id');
    //localStorage.setItem('auth__customer_id', state.customer_id);
  },
  AUTH_SET_CUSTOMER_NAME: function(state, customer_name){
    state.customer_name = cleanMutationValue(customer_name);
    setLocalStorageItem(state, 'customer_name');
    //localStorage.setItem('auth__customer_name', state.customer_name);
  },
  AUTH_SET_CUSTOMER_CONTACT_ID: function(state, customer_contact_id){
    state.customer_contact_id = cleanMutationValue(customer_contact_id);
    setLocalStorageItem(state, 'customer_contact_id');
    //localStorage.setItem('auth__customer_contact_id', state.customer_contact_id);
  },
  AUTH_SET_CUSTOMER_CONTACT_NAME: function(state, customer_contact_name){
    state.customer_contact_name = cleanMutationValue(customer_contact_name);
    setLocalStorageItem(state, 'customer_contact_name');
    //localStorage.setItem('auth__customer_contact_name', state.customer_contact_name);
  },
  AUTH_SET_USER_LAST_UPDATE: function(state, user_last_update){
    state.user_last_update = cleanMutationValue(user_last_update);
    setLocalStorageItem(state, 'user_last_update');
  },
  AUTH_SET_CUSTOMER_LAST_UPDATE: function(state, customer_last_update){
    state.customer_last_update = cleanMutationValue(customer_last_update);
    setLocalStorageItem(state, 'customer_last_update');
  },
  AUTH_SET_WELCOME_WATCHED: function(state, welcome_watched){
    state.welcome_watched = cleanMutationValue(welcome_watched);
    setLocalStorageItem(state, 'welcome_watched');
  },
  AUTH_SET_STATUS: function(state, status){
    state.status = cleanMutationValue(status);
  },
  AUTH_SET_ERROR: function(state, error){
    state.error = cleanMutationValue(error);
  },
  AUTH_AUTO_REFRESH: function(state, timeout){
    state.auto_refresh = timeout;
  },
  AUTH_CLEAR_AUTO_REFRESH: function(state){
    if(state.auto_refresh) {
      clearTimeout(state.auto_refresh);
    }
    state.auto_refresh = null;
  },
  'AUTH_SET_VALIDATION': function(state, validation){
    state.validation = validation;
  },
}

const actions = {

  CLEAR_AUTH: ({commit}) => {
    return new Promise((resolve) => {
      commit(AUTH_SET_STATUS, null);
      commit(AUTH_SET_USER_ID, null);
      commit(AUTH_SET_EMAIL, null);
      commit(AUTH_SET_ACCESS_TOKEN, null);
      commit(AUTH_SET_EXPIRY, null);
      commit(AUTH_SET_REFRESH_TOKEN, null);
      commit(AUTH_SET_ROLE, null);
      commit(AUTH_SET_CUSTOMER_ID, null);
      commit(AUTH_SET_CUSTOMER_NAME, null);
      commit(AUTH_SET_CUSTOMER_CONTACT_ID, null);
      commit(AUTH_SET_CUSTOMER_CONTACT_NAME, null);
      commit(AUTH_SET_STATUS, null);
      commit(AUTH_SET_USER_LAST_UPDATE, null);
      commit('AUTH_SET_VALIDATION', null);
      resolve();
    });
  },

  AUTH_LOGOUT: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'sign_out__request');
      return dispatch(CLEAR_AUTH).then((data) => {
        dispatch('entities/deleteAll');
        dispatch(CLEAR_FETCH_CACHE);
        return resolve(data);
      }, (err) => {
        commit(AUTH_SET_STATUS, 'sign_out__error');
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Sign up error'));
        return reject(err);
      });
    });
  },

  AUTH_LOGIN: ({commit, dispatch}, {username, password}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'SIGN_IN_REQUEST');
      dispatch('entities/deleteAll');
      dispatch(CLEAR_FETCH_CACHE);
      let r = AuthRepository.login(username, password).then((response) => {
        let data = response.data;
        if(data.challenge && data.challenge === 'NEW_PASSWORD_REQUIRED') {
          commit(AUTH_SET_STATUS, 'SIGN_IN_CHALLENGE');
          if(data.session) {
            commit(AUTH_SET_ACCESS_SESSION, data.session);
            return resolve();
          } else {
            throw 'Password request required but no session was provided';
          }
        } else {
          let user = data.user;
          commit(AUTH_SET_STATUS, 'SIGN_IN_SUCCESS');
          commit(AUTH_SET_USER_ID, user.id);
          commit(AUTH_SET_EMAIL, user.email);
          commit(AUTH_SET_USER_LAST_UPDATE, user.updated_at);
          commit(AUTH_SET_ACCESS_TOKEN, data.access_token);
          commit(AUTH_SET_REFRESH_TOKEN, data.refresh_token);
          commit(AUTH_SET_EXPIRY, data.expires_at);
          if(user.roles && user.roles.length) {
            let roles = user.roles.map((role) => role.name);
            commit(AUTH_SET_ROLE, roles[0]);
            if(roles.includes('CustomerContact') && user.customer_contact && user.customer_contact.customer) {
              commit(AUTH_SET_CUSTOMER_ID, user.customer_contact.customer.id);
              commit(AUTH_SET_CUSTOMER_NAME, user.customer_contact.customer.name);
              commit(AUTH_SET_CUSTOMER_CONTACT_ID, user.customer_contact.id);
              commit(AUTH_SET_CUSTOMER_CONTACT_NAME, user.customer_contact.contact.full_name);
              commit(AUTH_SET_CUSTOMER_LAST_UPDATE, user.customer_contact.customer.updated_at);
              return resolve();
            } else if(roles.includes('EmployeeContact') || roles.includes('SuperAdmin')) {
              return resolve();
            } else {
              return dispatch(AUTH_LOGOUT).then((data) => {
                let msg = 'User is not authorized for this system';
                commit(AUTH_SET_ERROR, msg);
                return reject(msg);
              }, (err) => {
                commit(AUTH_SET_STATUS, 'SIGN_IN_ERROR');
                let msg = parseErrResponse(err.response ? err.response.data : err);
                commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Authentication failed'));
                return reject(err);
              });
            }
          } else {
            return dispatch(AUTH_LOGOUT).then((data) => {
              return resolve(data);
            }, (err) => {
              commit(AUTH_SET_STATUS, 'SIGN_IN_ERROR');
              let msg = parseErrResponse(err.response ? err.response.data : err);
              commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Authentication failed'));
              return reject(err);
            });
          }
        }
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'SIGN_IN_ERROR');
        let msg = parseErrResponse(err.response ? err.response.data : err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Authentication failed'));
        return reject(err);
      });
      return r;
    });
  },

  AUTH_RESET_PASSWORD: ({commit, state}, {username, password}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'RESET_REQUEST_REQUEST');
      if(state.access_session) {
        return AuthRepository.resetPassword(username, password, state.access_session).then((response) => {
          //let data = response.data;
          return resolve();
        }).catch((err) => {
          commit(AUTH_SET_STATUS, 'RESET_REQUEST_ERROR');
          let msg = parseErrResponse(err.response ? err.response.data : err);
          commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Password reset failed'));
          return reject(err);
        });
      } else {
        commit(AUTH_SET_STATUS, 'RESET_REQUEST_ERROR');
        commit(AUTH_SET_ERROR, 'Session missing when resetting password');
        return reject('Session missing when resetting password');
      }
    });
  },

  AUTH_REQUEST_RESET: ({commit}, {username}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'REQUEST_RESET_REQUEST_REQUEST');
      return AuthRepository.requestReset(username).then(() => {
        return resolve();
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'REQUEST_RESET_REQUEST_ERROR');
        let msg = parseErrResponse(err.response ? err.response.data : err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Password reset failed'));
        return reject(err);
      });
    });
  },

  AUTH_CONFIRM_RESET: ({commit}, {username, code, password}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'CONFIRM_RESET_REQUEST');
      return AuthRepository.confirmReset(username, code, password).then(() => {
        return resolve();
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'CONFIRM_RESET_ERROR');
        let msg = parseErrResponse(err.response ? err.response.data : err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Password reset failed'));
        return reject(err);
      });
    });
  },

  async AUTH_CHECK_LOGIN ({state, commit, dispatch}) {
    let r = await (new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'refresh__request');
      if(!state.access_token || !state.refresh_token || !state.role) {
        return reject();
      } else {
        commit(AUTH_CLEAR_AUTO_REFRESH);
        commit(AUTH_AUTO_REFRESH, setTimeout(() => {return dispatch(AUTH_CHECK_LOGIN)}, 60000));
        if(state.expiry && moment(state.expiry).diff(moment()) > 0) {
          return resolve(state.user_id);
        }
        return AuthRepository.refresh(state.refresh_token).then((response) => {
          let data = response.data;
          commit(AUTH_SET_STATUS, 'refresh__success');
          let user = data.user;
          commit(AUTH_SET_USER_ID, user.id);
          commit(AUTH_SET_EMAIL, user.email);
          commit(AUTH_SET_USER_LAST_UPDATE, user.updated_at);
          commit(AUTH_SET_ACCESS_TOKEN, data.access_token);
          commit(AUTH_SET_EXPIRY, data.expires_at);
          if(user.roles && user.roles.length) {
            let roles = user.roles.map((role) => role.name);
            commit(AUTH_SET_ROLE, roles[0]);
            if(roles.includes('CustomerContact') && user.customer_contact && user.customer_contact.customer) {
              commit(AUTH_SET_CUSTOMER_ID, user.customer_contact.customer.id);
              commit(AUTH_SET_CUSTOMER_NAME, user.customer_contact.customer.name);
              commit(AUTH_SET_CUSTOMER_CONTACT_ID, user.customer_contact.id);
              commit(AUTH_SET_CUSTOMER_CONTACT_NAME, user.customer_contact.full_name);
              return resolve();
            } else if(roles.includes('EmployeeContact') || roles.includes('SuperUser')) {
              return resolve();
            } else {
              return dispatch(AUTH_LOGOUT).then((data) => {
                return resolve(data);
              }, (err) => {
                commit(AUTH_SET_STATUS, 'REFRESH_ERROR');
                let msg = parseErrResponse(err.response ? err.response.data : err);
                commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Refresh failed'));
                return reject(err);
              });
            }
          }
          return resolve(data.id);
        }, (err) => {
          return reject(err);
        });
      }
    }));
    return r;
  },

  AUTH_WELCOME_WATCHED: ({commit}) => {
    return new Promise((resolve) => {
      commit(AUTH_SET_WELCOME_WATCHED, true);
      return resolve();
    });
  },

  async AUTH_VALIDATE_CUSTOMER ({state, commit}) {
    return new Promise((resolve, reject) => {
      if(state.validation) {
        return resolve(state.validation);
      }
      return AuthRepository.validate().then((response) => {
        let validation = response.data;
        commit('AUTH_SET_VALIDATION', validation);
        if(validation.customer) {
          Customer.insert({data: validation.customer});
        }
        if(validation.shipping_address) {
          Location.insert({data: validation.shipping_address});
        }
        if(validation.billing_address) {
          Location.insert({data: validation.billing_address});
        }
        if(validation.accounting_contact) {
          Contact.insert({data: validation.accounting_contact});
        }
        validation.customer_contacts.forEach(i => {
          if(i.customer_contact) {
            CustomerContact.insert({data: i.customer_contact});
          }
          // if(i.contact) {
          //   Contact.insert({data: i.contact});
          // }
          // if(i.location) {
          //   Location.insert({data: i.location});
          // }
          // if(i.user) {
          //   User.insert({data: i.user});
          // }
        });
        return resolve(validation);
      });
    });
  },

};

function parseErrResponse(err) {
  if(typeof err === 'string') {
    return err;
  } else if(typeof err === 'object') {
    return err.message;
  }
  return null;
}

export default {
  getters,
  mutations,
  actions,
  state
}
